import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  constructor(
    private router: Router,
  ) { }

  getAuthHttpHeader() {
    return new HttpHeaders({
      'Content-Type':  'application/x-www-form-urlencoded',
      Authorization:  'Basic ' + btoa('muinId:clientSecret')
    });
  }

  getAuthParams(id: string, password: string) {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('grant_type', 'password');
    urlSearchParams.append('username', id);
    urlSearchParams.append('password', password);
    const body = urlSearchParams.toString();
    return body;
  }

  getRefreshAuthParams() {
    let body = '';
    const refreshToken = sessionStorage.getItem('refresh_token');
    if (refreshToken !== null) {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append('grant_type', 'refresh_token');
      urlSearchParams.append('scope', 'read write');
      urlSearchParams.append('refresh_token', refreshToken);
      body = urlSearchParams.toString();
    }
    return body;
  }

  getAuthToken() {
    const tokenType = sessionStorage.getItem('token_type');
    const accessToken = sessionStorage.getItem('access_token');
    return `${ tokenType } ${ accessToken }`;
  }

  saveAuth(auth: any) {
    const expiresAt = Date.now() + (auth.expires_in * 1000);
    sessionStorage.setItem('expires_at', expiresAt.toString());
    sessionStorage.setItem('token_type', auth.token_type);
    sessionStorage.setItem('access_token', auth.access_token);
    sessionStorage.setItem('refresh_token', auth.refresh_token);
  }

  removeAuth() {
    sessionStorage.removeItem('token_type');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('autoSignin');
  }

  isAccessTokenExpired() {
    const expires = Number(sessionStorage.getItem('expires_at'));
    const expireDate = new Date(expires);
    return Date.now() >= expires;
  }

  signOut() {
    this.removeAuth();
    this.router.navigateByUrl('/signin', {replaceUrl: true});
  }
}

export const EXCLUDE_AUTH_URL = [
  '/signUp',
  '/signIn',
  '/signInRequestOtp',
  '/signInVerifyOtp',
  '/adsList',
  '/emailSend',
  '/searchId',
  '/createCaptchaImage',
  '/checkLoginAccount'
];